// Enlaza el motor de reglas al DOM del formulario público (ERB server-rendered).
// Lee las reglas embebidas, y en cada cambio muestra/oculta campos y filtra las
// opciones de los selects objetivo según los valores actuales.

import {
  allowedOptions,
  optionFilterTargets,
  RULE_TYPES,
} from './formRulesEngine';
import { computeHiddenFields } from './formFieldVisibility';

const FORM_ID = 'portal-form';
const RULES_NODE_ID = 'form-rules';

const readRules = () => {
  const node = document.getElementById(RULES_NODE_ID);
  if (!node) return [];
  try {
    const parsed = JSON.parse(node.textContent || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const collectValues = form => {
  const values = {};
  form.querySelectorAll('[name]').forEach(element => {
    if (!element.name) return;
    if (element.type === 'checkbox') {
      values[element.name] = element.checked ? 'true' : 'false';
    } else {
      values[element.name] = element.value;
    }
  });
  return values;
};

const visibilityTargets = rules => {
  const targets = new Set();
  rules
    .filter(rule => rule.type === RULE_TYPES.VISIBILITY)
    .forEach(rule =>
      (rule.target_fields || []).forEach(field => targets.add(field))
    );
  return targets;
};

const toggleControl = (control, isHidden) => {
  control.disabled = isHidden;
  if (isHidden) {
    if (control.required) {
      control.dataset.wasRequired = 'true';
      control.required = false;
    }
  } else if (control.dataset.wasRequired === 'true') {
    control.required = true;
    delete control.dataset.wasRequired;
  }
};

const applyVisibility = (rules, values) => {
  const targets = visibilityTargets(rules);
  const hidden = new Set(computeHiddenFields(rules, values));

  targets.forEach(name => {
    const wrapper = document.getElementById(`field-${name}`);
    if (!wrapper) return;

    const isHidden = hidden.has(name);
    wrapper.style.display = isHidden ? 'none' : '';
    wrapper
      .querySelectorAll('input, select, textarea')
      .forEach(control => toggleControl(control, isHidden));
  });
};

const promptFor = select => {
  if (select.dataset.prompt === undefined) {
    const emptyOption = Array.from(select.options).find(
      option => option.value === ''
    );
    select.dataset.prompt = emptyOption ? emptyOption.textContent : '';
  }
  return select.dataset.prompt;
};

const rebuildOptions = (select, allowed, promptText) => {
  const current = select.value;
  select.innerHTML = '';

  const prompt = document.createElement('option');
  prompt.value = '';
  prompt.textContent = promptText;
  select.appendChild(prompt);

  allowed.forEach(optionValue => {
    const option = document.createElement('option');
    option.value = optionValue;
    option.textContent = optionValue;
    select.appendChild(option);
  });

  select.value = allowed.includes(current) ? current : '';
};

const applyOptionFilters = (rules, values) => {
  optionFilterTargets(rules).forEach(name => {
    const select = document.getElementById(`select-${name}`);
    if (!select) return;

    let allOptions = [];
    try {
      allOptions = JSON.parse(select.dataset.allOptions || '[]');
    } catch (error) {
      allOptions = [];
    }

    const promptText = promptFor(select);
    const allowed = allowedOptions(rules, values, name, allOptions);
    rebuildOptions(select, allowed, promptText);
  });
};

const evaluate = (form, rules) => {
  const values = collectValues(form);
  applyVisibility(rules, values);
  applyOptionFilters(rules, values);
};

export const initFormRules = () => {
  const form = document.getElementById(FORM_ID);
  if (!form || form.dataset.rulesInitialized === 'true') return;

  const rules = readRules();
  if (!rules.length) return;

  form.dataset.rulesInitialized = 'true';
  const run = () => evaluate(form, rules);
  form.addEventListener('change', run);
  form.addEventListener('input', run);
  run();
};
